<div page-content [fullWidth]="true">
  <div inner>

    <!-- Initial full-page spinner -->
    @if (loading) {
      <div class="uk-flex uk-flex-center uk-margin-large-top">
        <span data-uk-spinner="ratio: 2"></span>
      </div>
    }

    @if (!loading) {
      <div class="uk-flex uk-flex-right uk-margin-medium-top uk-margin-medium-left uk-margin-medium-right">
        <button class="uk-button uk-button-primary uk-button-small uk-border-rounded uk-flex uk-flex-middle"
                (click)="openAddModal()">
          <span class="material-symbols-outlined uk-margin-small-right">add</span>
          ADD
        </button>
      </div>
      <div
        class="uk-flex uk-flex-between uk-flex-middle uk-margin-medium-top uk-margin-medium-left uk-margin-medium-right">
        <div class="uk-flex uk-flex-left uk-flex-middle">

          <!-- Sort dropdown -->
          <div class="uk-inline uk-margin-small-right">
            <button class="uk-button uk-button-default" type="button">Sort</button>
            <div id="sortDropdown" data-uk-dropdown="mode: click; pos: bottom-left; auto-update: true;">
              <div>
                <div style="overflow: visible;">
                  <ng-select [items]="sortOptions" bindLabel="label" bindValue="value" [isOpen]="true"
                             placeholder="Sort by" [closeOnSelect]="false" class="open" [appendTo]="''"
                             [dropdownPosition]="'bottom'" [(ngModel)]="sort"
                             (change)="onSortChange()" [clearable]="false"
                             (remove)="onSortRemove(sort)">
                    <ng-template ng-option-tmp let-item="item">
                      {{ item.label }}
                    </ng-template>

                  </ng-select>
                  <button class="uk-button uk-button-primary uk-margin-top uk-float-right" type="button"
                          (click)="applyFilter('sortDropdown')">Apply
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Order dropdown -->
          <div class="uk-inline uk-margin-small-right">
            <button class="uk-button uk-button-default" type="button">Order</button>
            <div id="orderDropdown" data-uk-dropdown="mode: click; pos: bottom-left; auto-update: true;">
              <div>
                <div style="overflow: visible;">
                  <ng-select [items]="orderOptions" bindLabel="label" bindValue="value" [isOpen]="true"
                             placeholder="Order by" [closeOnSelect]="false" class="open" [appendTo]="''"
                             [dropdownPosition]="'bottom'" [(ngModel)]="order"
                             (change)="onOrderChange()" [clearable]="false"
                             (remove)="onOrderRemove(order)">
                    <ng-template ng-option-tmp let-item="item">
                      {{ item.label }}
                    </ng-template>

                  </ng-select>
                  <button class="uk-button uk-button-primary uk-margin-top uk-float-right" type="button"
                          (click)="applyFilter('orderDropdown')">Apply
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Active dropdown -->
          <div class="uk-inline uk-margin-small-right">
            <button class="uk-button uk-button-default" type="button">Active</button>
            <div id="activeDropdown" data-uk-dropdown="mode: click; pos: bottom-left; auto-update: true;">
              <div>
                <div style="overflow: visible;">
                  <ng-select [items]="activeOptions" bindLabel="label" bindValue="value" [isOpen]="true"
                             placeholder="Status" [closeOnSelect]="false" class="open" [appendTo]="''"
                             [multiple]="true" [dropdownPosition]="'bottom'" [(ngModel)]="activeFilter"
                             (change)="onActiveChange()" (remove)="onActiveRemove(activeFilter)"
                             [clearable]="false">
                    <ng-template ng-option-tmp let-item="item">
                      {{ item.label }}
                    </ng-template>
                  </ng-select>
                  <button class="uk-button uk-button-primary uk-margin-top uk-float-right" type="button"
                          (click)="applyFilter('activeDropdown')">Apply
                  </button>
                </div>
              </div>
            </div>
          </div>

          @if (showClearFilter()) {
            <span class="material-symbols-outlined uk-margin-small-left uk-cursor-pointer" style="cursor: pointer"
                  (click)="clearFilters()" data-uk-tooltip="Clear All">delete
            </span>
          }

        </div>

        <div class="uk-flex uk-flex-middle" style="gap: 8px;">
          <div class="uk-inline">
            <span class="uk-form-icon" data-uk-icon="icon: search"></span>
            <input #searchInput type="text" class="uk-input menuSearch" placeholder="Search..."
                   [value]="keyword"
                   (input)="keywordSubject.next(searchInput.value)"
                   style="border-radius: 20px;">
          </div>
        </div>
      </div>

      <!-- Badge container -->
      <div class="badge-container uk-margin-bottom uk-flex uk-margin-medium-left uk-margin-medium-right">
        <div>
          @if (appliedSort !== 'creationDate') {
            <span class="filter-badge">
              <strong>Sort: &nbsp;</strong>{{ getOptionLabel(sortOptions, appliedSort) }}
              <button class="remove-btn" type="button" (click)="removeSortFilter()">x</button>
            </span>
          }
          @if (appliedOrder !== 'desc') {
            <span class="filter-badge">
              <strong>Order: &nbsp;</strong>{{ getOptionLabel(orderOptions, appliedOrder) }}
              <button class="remove-btn" type="button" (click)="removeOrderFilter()">x</button>
            </span>
          }
          @if (appliedActive !== 'all') {
            <span class="filter-badge">
              <strong>Active: &nbsp;</strong>{{ getOptionLabel(activeOptions, appliedActive) }}
              <button class="remove-btn" type="button" (click)="removeActiveFilter()">x</button>
            </span>
          }
          @if (keyword) {
            <span class="filter-badge">
              <strong>Keyword: &nbsp;</strong>{{ keyword }}
              <button class="remove-btn" type="button" (click)="removeKeywordFilter()">x</button>
            </span>
          }
        </div>
      </div>

      <!-- Table  -->
      @if (newsItems.length > 0) {
        <div
          class="uk-overflow-auto uk-margin-medium-left uk-margin-medium-right uk-card uk-card-default uk-border-rounded">
          <table class="uk-table uk-table-divider uk-table-middle uk-margin-remove">
            <thead>
            <tr>
              <th class="uk-width-expand">STORY INFO</th>
              <th class="uk-width-shrink">IMAGE</th>
              <th>URL / LINK</th>
              <th>PUBLISH DATE</th>
              <th>ACTIONS</th>
            </tr>
            </thead>
            <tbody>
            <!-- Table-level spinner: only the tbody refreshes, the input above stays alive -->
              @if (searching) {
                <tr>
                  <td colspan="5" class="uk-text-center uk-padding">
                    <span data-uk-spinner="ratio: 1"></span>
                  </td>
                </tr>
              } @else {
                @for (item of newsItems; track item.result.id) {
                  <tr>
                    <td>
                      <div class="uk-text-bold" [innerHTML]="getHighlightForField(item, 'title') ?? item.result.title"></div>
                      <div class="uk-text-meta multi-line-ellipsis" [innerHTML]="getHighlightForField(item, 'description') ?? item.result.description"></div>
                    </td>
                    <td>
                      @if (item.result.image) {
                        <img [src]="item.result.image" width="45" height="45" class="uk-border-rounded"
                             [alt]="'No image provided'">
                      } @else {
                        <span class="uk-text-muted" style="font-size: 0.75rem;">No image provided</span>
                      }
                    </td>
                    <td>
                      @if (item.result.url) {
                        <a [href]="item.result.url" target="_blank"
                           class="uk-link-text uk-text-truncate uk-display-block"
                           style="max-width: 200px;" [title]="item.result.url">
                          <!--                        <span class="material-symbols-outlined uk-text-middle uk-margin-small-right"-->
                          <!--                              style="font-size: 18px;">link</span>-->
                          {{ item.result.url }}
                        </a>
                      } @else {
                        <span class="uk-text-muted uk-text-italic">No link provided</span>
                      }
                    </td>
                    <td class="uk-text-nowrap">
                      <div class="uk-text-small">{{ item.result.publishDate | date:'MMM dd, yyyy' }}</div>
                      <div class="uk-text-meta" style="font-size: 0.7rem;">
                        Expires: {{ item.result.expiryDate | date:'dd/MM/yy' }}
                      </div>
                    </td>
                    <td>
                      <div class="uk-flex uk-flex-middle" style="gap: 12px;">
                        <a class="uk-flex uk-flex-middle"
                           uk-tooltip="Preview"
                           style="text-decoration: none; color: inherit; cursor: pointer;"
                           (click)="openPreviewModal(item)">
                          <span class="material-symbols-outlined" style="font-size: 16px;">preview</span>
                        </a>
                        <a class="uk-flex uk-flex-middle"
                           uk-tooltip="Edit"
                           style="text-decoration: none; color: inherit; cursor: pointer;"
                           (click)="openUpdateModal(item)">
                          <span class="material-symbols-outlined" style="font-size: 16px;">edit</span>
                        </a>
                        <a class="uk-flex uk-flex-middle"
                           uk-tooltip="Delete"
                           style="text-decoration: none; color: inherit; cursor: pointer;"
                           (click)="openDeleteModal(item)">
                          <span class="material-symbols-outlined" style="font-size: 16px;">delete</span>
                        </a>
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      } @else {
        <div class="uk-text-center uk-margin-large-top">
          <p class="uk-text-large uk-text-muted uk-margin-small-top">No news available.</p>
        </div>
      }

      @if (totalPages > 1) {
        <div
          class="uk-flex uk-flex-middle uk-flex-between uk-margin-medium-top uk-margin-medium-left uk-margin-medium-right uk-margin-medium-bottom">
          <p class="uk-margin-remove uk-text-small">
            Results <span class="uk-text-bold">{{ (currentPage - 1) * pageSize + 1 }}</span>–<span
            class="uk-text-bold">{{ (currentPage - 1) * pageSize + newsItems.length }}</span> of <span
            class="uk-text-bold">{{ total }}</span>
          </p>
          <ul class="uk-pagination uk-margin-remove">
            @if (currentPage > 2 && totalPages > 5) {
              <li><a (click)="goToPage(1)"><span data-uk-pagination-previous></span><span
                data-uk-pagination-previous></span></a></li>
            }
            @if (currentPage !== 1) {
              <li><a (click)="previousPage()"><span data-uk-pagination-previous></span></a></li>
            }
            @for (i of pages; track i) {
              <li [class.uk-active]="i === currentPage"><a (click)="goToPage(i)">{{ i }}</a></li>
            }
            @if (currentPage !== totalPages) {
              <li><a (click)="nextPage()"><span data-uk-pagination-next></span></a></li>
            }
            @if (currentPage < totalPages - 1 && totalPages > 5) {
              <li><a (click)="goToPage(totalPages)"><span data-uk-pagination-next></span><span
                data-uk-pagination-next></span></a></li>
            }
          </ul>
        </div>
      }
    }

  </div>
</div>

<!-- Add / Edit Modal -->
<div id="story-modal" uk-modal>
  <div class="uk-modal-dialog uk-modal-body uk-border-rounded">
    <button class="uk-modal-close-default" type="button" uk-close></button>

    <h2 class="uk-modal-title uk-text-bold">
      {{ isUpdateMode ? 'Update Story' : 'Add New Story' }}
    </h2>

    <form [formGroup]="storyForm" (ngSubmit)="onSubmit()" class="uk-form-stacked uk-margin-medium-top"
          autocomplete="off">
      <div class="uk-margin">
        <label class="uk-form-label uk-text-bold">Title *</label>
        <div class="uk-form-controls">
          <input class="uk-input uk-border-rounded" type="text" formControlName="title"
                 name="news-title" autocomplete="off" placeholder="Enter story title...">
        </div>
      </div>

      <div class="uk-margin">
        <label class="uk-form-label uk-text-bold">Description</label>
        <div class="uk-form-controls">
          <textarea class="uk-textarea uk-border-rounded" rows="3" formControlName="description"
                    name="news-description" autocomplete="off" placeholder="Describe the story...">
          </textarea>
        </div>
      </div>
      <div class="uk-margin">
        <label class="uk-form-label uk-text-bold">External Link (URL)</label>
        <div class="uk-form-controls">
          <input class="uk-input uk-border-rounded" type="url" formControlName="url"
                 name="news-url" autocomplete="off" placeholder="https://example.com">
          @if (storyForm.get('url')?.errors?.['pattern'] && storyForm.get('url')?.touched) {
            <p class="uk-text-danger uk-text-small uk-margin-small-top">
              URL must be a valid URL starting with http:// or https://
            </p>
          }
        </div>
      </div>
      <div class="uk-margin">
        <label class="uk-form-label uk-text-bold">Image URL</label>
        <div class="uk-form-controls">
          <textarea class="uk-textarea uk-border-rounded" formControlName="image"
                    name="news-image" autocomplete="off" rows="2"
                    placeholder="https://example.com/image.jpg"></textarea>
          @if (storyForm.get('image')?.errors?.['pattern'] && storyForm.get('image')?.touched) {
            <p class="uk-text-danger uk-text-small uk-margin-small-top">
              Image must be a valid URL starting with http:// or https://
            </p>
          }
        </div>
      </div>
      <div class="uk-grid-small uk-child-width-1-2@s" uk-grid>
        <div>
          <label class="uk-form-label uk-text-bold">Publish Date *</label>
          <input class="uk-input uk-border-rounded" type="date" formControlName="publishDate">
        </div>
        <div>
          <label class="uk-form-label uk-text-bold">Expiry Date</label>
          <input class="uk-input uk-border-rounded" type="date" formControlName="expiryDate">
        </div>
      </div>

      <div
        class="uk-modal-footer uk-text-right uk-padding-remove-horizontal uk-margin-medium-top uk-background-default">
        <button class="uk-button uk-button-default uk-modal-close uk-border-rounded uk-margin-small-right"
                type="button">Cancel
        </button>
        <button class="uk-button uk-button-primary uk-border-rounded" type="submit"
                [disabled]="storyForm.invalid || submitting">
          {{ submitting ? 'Saving...' : (isUpdateMode ? 'Update Story' : 'Save Story') }}
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Preview Modal -->
<div id="preview-modal" uk-modal>
  <div class="uk-modal-dialog uk-border-rounded"
       style="width: 380px; max-width: 380px; margin: auto; padding: 0; overflow: hidden;">
    @if (selectedPreviewItem) {
      @if (selectedPreviewItem.result.image) {
        <img [src]="selectedPreviewItem.result.image"
             style="width: 100%; height: 200px; object-fit: cover; display: block;">
      }
      <div class="uk-modal-body">
        <p class="uk-text-meta uk-margin-remove-bottom">
          {{ selectedPreviewItem.result.publishDate | date:'dd MMMM yyyy' }}
        </p>
        <h5 class="uk-text-bold uk-margin-small-top uk-margin-small-bottom">
          {{ selectedPreviewItem.result.title }}
        </h5>
        <p class="uk-text-small multi-line-ellipsis" style="-webkit-line-clamp: 5">
          {{ selectedPreviewItem.result.description }}
        </p>
        @if (selectedPreviewItem.result.url) {
          <a [href]="selectedPreviewItem.result.url" target="_blank"
             class="uk-button uk-button-primary uk-button-small uk-border-rounded uk-margin-small-top">
            Read more
          </a>
        }
      </div>
    }
  </div>
</div>

<!-- Delete Modal -->
<div id="delete-modal" uk-modal>
  <div class="uk-modal-dialog uk-modal-body uk-border-rounded">
    <h3 class="uk-modal-title">Delete Article</h3>
    <p>Are you sure you want to delete this article?<br>
      <span class="uk-text-danger">This action cannot be undone.</span>
    </p>
    <div class="uk-flex uk-flex-right uk-margin-top">
      <button class="uk-button uk-button-default uk-modal-close uk-border-rounded uk-margin-small-right">
        Cancel
      </button>
      <button class="uk-button uk-button-danger uk-border-rounded" [disabled]="deleting" (click)="onDelete()">
        @if (deleting) {
          Deleting...
        } @else {
          Delete
        }
      </button>
    </div>
  </div>
</div>
